"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAccount = void 0;
const unit_1 = require("@keplr-wallet/unit");
class BaseAccount {
    constructor(type, address, accountNumber, sequence) {
        this.type = type;
        this.address = address;
        this.accountNumber = accountNumber;
        this.sequence = sequence;
    }
    static fetchFromRest(instance, address, 
    // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield instance.get(`auth/accounts/${address}`);
            return BaseAccount.fromAminoJSON(result.data, defaultBech32Address ? address : "");
        });
    }
    static fromAminoJSON(obj, 
    // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = "") {
        if ("height" in obj) {
            obj = obj.result;
        }
        const type = obj.type;
        if (!type) {
            throw new Error(`Account's type is unknown: ${JSON.stringify(obj)}`);
        }
        let value = obj.value;
        // If the account is the vesting account that embeds the base vesting account,
        // the actual base account exists under the base vesting account.
        // But, this can be different according to the version of cosmos-sdk.
        // So, anyway, try to parse it by some ways...
        const baseVestingAccount = value.BaseVestingAccount ||
            value.baseVestingAccount ||
            value.base_vesting_account;
        if (baseVestingAccount) {
            value =
                baseVestingAccount.BaseAccount ||
                    baseVestingAccount.baseAccount ||
                    baseVestingAccount.base_account;
        }
        let address = value.address;
        if (!address) {
            if (!defaultBech32Address) {
                throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            }
            address = defaultBech32Address;
        }
        const accountNumber = value.account_number;
        if (accountNumber == null) {
            throw new Error(`Account's account number is unknown: ${JSON.stringify(obj)}`);
        }
        const sequence = value.sequence;
        return new BaseAccount(type, address, new unit_1.Int(accountNumber), new unit_1.Int(sequence !== null && sequence !== void 0 ? sequence : "0"));
    }
    getType() {
        return this.type;
    }
    getAddress() {
        return this.address;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    getSequence() {
        return this.sequence;
    }
}
exports.BaseAccount = BaseAccount;
//# sourceMappingURL=index.js.map